import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useSearchParams } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import { useEffect } from "react";
import Loader from "@componentsShared/Loader/Loader";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import { useTranslation } from "@i18n";
var PaymentProcessing = function PaymentProcessing() {
  var _searchParams$get;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var paymentStatus = (_searchParams$get = searchParams.get("status")) !== null && _searchParams$get !== void 0 ? _searchParams$get : searchParams.get("in_status");
  var paymentMessage = searchParams.get("message") || searchParams.get('paymentMessage') || tShort('arib/payment_error');
  var post_id = useAribFinance().queryParams.post_id;
  var handleNavigation = function handleNavigation() {
    if (paymentStatus === "paid") {
      return navigateTo("/finance-apply-arib", {
        financestep: 3,
        post_id: post_id,
        paymentMessage: paymentMessage,
        payment_status: 1
      });
    }
    navigateTo("/finance-apply-arib", {
      financestep: 10,
      post_id: post_id,
      paymentMessage: paymentMessage,
      payment_success: 0
    });
  };
  useEffect(function () {
    handleNavigation();
  }, []);
  return /*#__PURE__*/React.createElement(Loader, null);
};
export default PaymentProcessing;